<template>
    <div v-if="data" class="billing-form" v-loading="loading">
        <h2>{{ data.name }}</h2>

        <div class="bil-item">
            <div class="bil-label">Status:</div>
            <select class="form-control" v-model="data.status">
                <option v-for="s in status_options" :value="s.id">{{ s.name }}</option>
            </select>
        </div>
        <div class="bil-item">
            <div class="bil-label">Account Manager:</div>
            <select class="form-control" v-model="data.accountManager.account_manager_id">
                <option v-for="am in data.accountManager.options" :value="am.id">{{ am.name }}</option>
            </select>
        </div>

        <template v-if="data.status === 'Not Advertising'">
            <h2>Churn</h2>
            <div class="bil-item">
                <div class="bil-label">Churn reason:</div>
                <select class="form-control" v-model="data.churn.reason">
                    <option v-for="reason in churnReasons" :value="reason">{{ reason }}</option>
                </select>
            </div>
            <div class="bil-item" style="align-items: baseline">
                <div class="bil-label">Churn notes:</div>
                <textarea class="form-control" v-model="data.churn.notes"></textarea>
            </div>
        </template>

        <template v-if="data.status !== 'Not Advertising'">
            <h2>Agency</h2>
            <div class="bil-item">
                <div class="bil-label">Agency:</div>
                <select class="form-control" v-model="data.agency.agency_id">
                    <option v-for="s in agency_list" :value="s.id">{{ s.name }}</option>
                </select>
            </div>
            <div class="bil-item">
                <div class="bil-label">Discount:</div>
                <div style="width:100%">
                    <div class="input-group">
                        <span class="input-group-addon">%</span>
                        <input type="text" class="form-control" v-model="data.agency.discount">
                    </div>
                </div>
            </div>

            <div class="bil-item">
                <div class="bil-label">IO number:</div>
                <input type="text" class="form-control" v-model="data.agency.io_number">
            </div>

            <h2>Billing</h2>
            <div class="bil-item">
                <div class="bil-label">Billable</div>
                <div class="input-group">
                    <span class="input-group-addon">$</span>
                    <input type="text" class="form-control" style="width: 160px;" v-model="data.billing.billable">
                </div>
            </div>
            <div class="bil-item">
                <div class="bil-label">Billing Method:</div>
                <select class="form-control" style="width: 193px;" v-model="data.billing.method">
                    <option value="">Not selected</option>
                    <option value="invoice">Invoice</option>
                    <option value="credit-card">Credit Card</option>
                </select>
            </div>
            <div class="bil-item">
                <div class="bil-label">Billing Timeframe:</div>
                <select class="form-control" style="width: 193px;" v-model="data.billing.timeframe">
                    <option value="">Not selected</option>
                    <option value="Pre-pay">Pre-pay</option>
                    <option value="Post-pay">Post-pay</option>
                </select>
            </div>
            <div class="cd-section" style="margin-top: 20px;">
                <el-radio label="cpa" v-model="data.billing.type">Cost per Lead (CPL)</el-radio><br>
                <el-radio label="subscription" v-model="data.billing.type">Subscription</el-radio><br>
                <el-radio label="cph" v-model="data.billing.type">Cost per Hire (CPH)</el-radio><br>
                <el-radio label="trial" v-model="data.billing.type">Trial, free of charge</el-radio>
            </div>
            <div class="cd-section">
                <el-checkbox label="Rollover" v-model="data.rollover"></el-checkbox>
            </div>

            <h2>Term</h2>
            <div class="cd-section">
                <div style="display: flex; align-items: center; margin-left: 25px;">
                    Term
                    <input type="date" class="form-control" style="width: 160px; margin: 0 15px;"
                           v-model="data.term.date_from"></input>
                    -
                    <input type="date" class="form-control" style="width: 160px; margin: 0 15px;"
                           v-model="data.term.date_to"></input>
                </div>
            </div>
            <div class="cd-section">
                <div style="display: flex; align-items: baseline;">
                    <el-checkbox v-model="data.term.autorenewal">Autorenewal, each term:</el-checkbox>
                    <input type="text" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.term.autorenewal_months"></input>
                    <div>months</div>
                </div>
            </div>
        </template>

        <div v-if="!no_save_btn" style="text-align: center; margin-top: 10px;">
            <btn icon="fas fa-cloud-upload-alt" cssClass="btn-lg btn-primary" :click="() => save()">Save</btn>
        </div>
    </div>
</template>

<script>
const listOfChurnReasons = [
    '',
    'Quantity',
    'Quality',
    'Client internal',
    'Full',
    'Temporary pause',
    'No reason given',
    'Onboard incomplete'
];

export default {
    props: [
        'billing_period_id',
        'side',
        'no_save_btn',
    ],
    data() {
        return {
            status_options: [
                { id: 'Confirmed', name: 'Confirmed' },
                { id: 'Unconfirmed', name: 'Unconfirmed' },
                { id: 'Assumed', name: 'Assumed' },
                { id: 'Not Advertising', name: 'Not Advertising' },
            ],
            agency_list: [],
            data: null,
            loading: true,
        };
    },
    computed: {
        churnReasons() {
            const selectedReason = this.data.churn.reason;
            if (selectedReason == '' || selectedReason == null || listOfChurnReasons.indexOf(selectedReason) !== -1) {
                return listOfChurnReasons;
            }
            return [...listOfChurnReasons, ...[selectedReason]];
        },
    },
    watch: {
        billing_period_id() {
            this.refresh();
        },
        'data.status': function (newValue, oldValue) {
            this.$emit('refresh-data', this.data);
        },
        'data.billing.billable': function (newValue, oldValue) {
            this.$emit('refresh-data', this.data);
        },
        'data.agency.discount': function (newValue, oldValue) {
            this.$emit('refresh-data', this.data);
        },
        'data.agency.io_number': function (newValue, oldValue) {
            this.$emit('refresh-data', this.data);
        },
    },
    methods: {
        save() {
            return this.saveRequest();
        },
        saveRequest() {
            return axios.post(url(`admin/budget-billing/${this.billing_period_id}/store`), this.data)
                        .then(response => {
                            return this.refresh();
                        });
        },
        refresh() {
            this.loading = true;
            return axios.get(url(`admin/budget-billing/${this.billing_period_id}`))
                        .then(response => {
                            this.data = response.data;
                            this.loading = false;
                        });
        },
    },
    created() {
        axios.get(url(`admin/agency-list`))
             .then(response => {
                 this.agency_list = response.data.list;
             });
        this.refresh();
    },
};
</script>

<style>
.bil-label {
    width: 150px;
}

.bil-item {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.billing-form h2 {
    margin-top: 20px;
}
</style>
